export default __webpack_public_path__ + "static/media/nav_science.4b8215c0.svg";